<!-- Ported from the Polaris kit: src/components/ui/empty/EmptyDescription.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <p
    data-slot="empty-description"
    :class="
      cn(
        'text-polaris-muted-foreground [&>a:hover]:text-polaris-primary type-polaris-body leading-relaxed [&>a]:underline [&>a]:underline-offset-4',
        props.class
      )
    "
  >
    <slot />
  </p>
</template>
